import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  effect,
  HostBinding,
  inject,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { Header } from './shared/components/header/header';
import {
  BrFooter,
  BrFooterLegal,
} from '@govbr-ds/webcomponents-angular/standalone';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { DatePickerConf } from './core/config/date-picker.conf';

import { GlobalMessageComponent } from './shared/components/global-message/global-message.component';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { Title } from './shared/components/title/title';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SimulationBannerComponent } from './shared/components/simulation-banner/simulation-banner.component';
import { AuthService } from './shared/services/auth.services';
import { BreadcrumbDinamicoService } from './shared/services/breadcrumb-dinamico.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Header,
    Title,
    BrFooter,
    BrFooterLegal,
    GlobalMessageComponent,
    FormsModule,
    LoadingComponent,
    CommonModule,
    SimulationBannerComponent,
  ],
  providers: [provideFlatpickrDefaults(new DatePickerConf())],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements AfterViewInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly breadcrumbDinamico = inject(BreadcrumbDinamicoService);
  private readonly cdr = inject(ChangeDetectorRef);
  private crumbsBase: { label: string; url?: string }[] = [];

  constructor() {
    // Telas podem substituir o rótulo do último item (ex.: nome do profissional) depois de carregar os dados.
    effect(() => {
      this.breadcrumbDinamico.rotuloFinal();
      this.aplicarCrumbs();
      this.cdr.markForCheck();
    });
  }

  @HostBinding('attr.translate')
  readonly traduzir = 'no';

  @HostBinding('class.notranslate')
  readonly classeNaoTraduzir = true;

  title = 'Plataforma de Gerenciamento de Programas de Provimento - PGP';

  crumbs: { label: string; url?: string; active?: boolean }[] = [];
  showHeader = true;
  showFooter = true;

  ngAfterViewInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let currentRoute = this.activatedRoute;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }

        this.crumbsBase = this.resolveBreadcrumb(currentRoute);
        this.aplicarCrumbs();
        const path = currentRoute.snapshot.routeConfig?.path;
        if (path === 'login' || path === 'ouvidoria') {
          this.showHeader = false;
          this.showFooter = false;
        } else {
          this.showHeader = true;
          this.showFooter = true;
        }
      });
  }

  private aplicarCrumbs(): void {
    const rotulo = this.breadcrumbDinamico.rotuloFinal();
    const base = this.crumbsBase;
    this.crumbs = base.map((item, index) => ({
      ...item,
      label: rotulo && index === base.length - 1 ? rotulo : item.label,
      active: base.length - 1 === index,
    }));
  }

  private resolveBreadcrumb(route: ActivatedRoute): { label: string; url?: string }[] {
    const breadcrumbByRole = route.snapshot.data['breadcrumbByRole'] as
      | {
          role: string;
          breadcrumb: { label: string; url?: string }[];
        }[]
      | undefined;

    if (breadcrumbByRole) {
      const byRole = breadcrumbByRole.find((config) => this.authService.hasRole(config.role));
      if (byRole) {
        return byRole.breadcrumb;
      }
    }

    return (route.snapshot.data['breadcrumb'] as { label: string; url?: string }[] | undefined) ?? [];
  }
}
